import * as yup from 'yup';
import i18n from 'i18next';

const schema = yup.object().shape({
  description: yup.string().required(() => i18n.t('bookings.request.validations.required')).nullable(),
  number_of_guests: yup.number().typeError(() => i18n.t('bookings.request.validations.required')).required(() => i18n.t('bookings.request.validations.required')),
});

export default schema;
